import { useMemo, useState } from "react";
import "./transaction.css";
import CardCustom from "../../components/card";
import { TableCustomProps } from "../../components/table/table";
import { LottiesComponent } from "../../components/loadingLotties/LottiesComponent";
import cardLottie from "../../assets/lottie/target.json";
import useFetchTransactions from "../../service/userTransactions/getTransaction";
import TableMaterial from "../../components/tableMaterial/tableMaterial";
import ButtonUI from "../../components/button/buttons";
import InfoIcon from "@mui/icons-material/Info";
import { Box, Tab, Tabs } from "@mui/material";
import useFetchErrorLogs from "../../service/errorLogsService/errorLogsService";

const Developers = () => {
  const storedToken = sessionStorage.getItem("userData");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endStarDate, setEndStartDate] = useState<Date | null>(null);
  const [selectedTransaction, setSelectTransaction] = useState<null>(null);

  const [openModal, setOpenModal] = useState(false);
  const [email, setEmail] = useState<string>("");
  const [searchClicked, setSearchClicked] = useState(false);
  const [tabMovements, setTabMovements] = useState("APPROVED");

  const handleOpenModal = (transaction: any) => {
    setOpenModal(true);
    setSelectTransaction(transaction);
    // setOpenModal(true);
  };

  const transformDataToTable = (
    transactions: any[]
  ): TableCustomProps["rows"] => {
    const translations: { [key: string]: string } = {
      APPROVED: "Aprobado",
      DECLINED: "Rechazado",
      PENDING: "Pendiente",
      FAILED: "Rechazado",
      charge_pending: "Pendiente",
    };

    const translateStatus = (status: string): string => {
      return translations[status] || status;
    };

    return transactions.map((transaction) => ({
      _id: transaction._id,
      email: transaction.email,
      client: transaction.client,
      error: "$ " + transaction.error,
      msg: "$ " + transaction.msg,
      created_at: new Date(transaction?.created_at).toLocaleDateString(
        "es-MX",
        {
          year: "numeric",
          month: "numeric",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          timeZone: "America/Mexico_City",
        }
      ),
    }));
  };

  const handleChange = (event: any, newValue: string) => {
    setTabMovements(newValue);
  };

  const buildFilters = (
    email?: string,
    startDate?: any,
    endDate?: any,
  ): any[] => {
    const filters = [];

    if (email) filters.push({ key: "email", value: email });
    if (startDate)
      filters.push({
        key: "created_at",
        value: new Date(startDate),
        operator: "$gte",
      });
    if (endDate)
      filters.push({
        key: "created_at",
        value: new Date(endDate),
        operator: "$lte",
      });
    return filters;
  };

  const filter = useMemo(
    () => buildFilters(email, startDate, endStarDate),
    [startDate, endStarDate, searchClicked]
  );

  const { logs, loading, error } = useFetchErrorLogs(
    storedToken || "",
    page,
    rowsPerPage,
    filter
  );

  const dataTable: any = {
    columns: [
      { id: "_id", label: "Id de error" },
      { id: "email", label: "Email" },
      { id: "client", label: "Client" },
      { id: "error", label: "Respuesta de API" },
      { id: "msg", label: "Msg" },
      { id: "created_at", label: "Fecha" },
    ],
    rows: transformDataToTable(logs?.data || []),
  };

  const hasData = logs;

  const onChangeEmail = (e: any) => {
    setEmail(e.target.value);
  };

  const handleSearchClick = () => {
    setSearchClicked((prev) => !prev);
  };

  function a11yProps(index: string) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }


  return (
    <div>
      {hasData ? (
        <CardCustom classCustom="activity_card">
          <h2>Desarrolladores</h2>
          <p>
          En esta sección, puedes gestionar y visualizar los errores, respuestas y validaciones generados por los servicios de transacciones.          </p>

          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={tabMovements}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              <Tab
                label="Lista de errores"
                {...a11yProps("APPROVED")}
                value="APPROVED"
              />
              {/* <Tab
                label="PENDIENTES"
                {...a11yProps("charge_pending")}
                value="charge_pending"
              />
              <Tab
                label="RECHAZADO"
                {...a11yProps("DECLINED")}
                value="DECLINED"
              /> */}
            </Tabs>
          </Box>
          <TableMaterial
            valueInput={email}
            onClickSearch={handleSearchClick}
            onChangeInput={onChangeEmail}
            isDate={true}
            setEndDate={setEndStartDate}
            setStartDate={setStartDate}
            startDate={startDate}
            endDate={endStarDate}
            totalRows={logs?.pagination?.countData}
            setPage={setPage}
            page={page}
            setRowsPerPage={setRowsPerPage}
            rowsPerPage={rowsPerPage}
            report={true}
            columns={dataTable.columns}
            rows={dataTable?.rows || []}
            loading={loading}
          />
        </CardCustom>
      ) : (
        <LottiesComponent
          style={{ width: "400px" }}
          title="Aun no tienes transacciones. Integra nuestra API en tu sitio y administra tus primeras transacciones"
          lotties={cardLottie}
        />
      )}
      {/* <ModalUI
        children={<TransactionModal data={selectedTransaction || []} />}
        title="Información de transacción"
        open={openModal}
        setOpen={setOpenModal}
      /> */}
    </div>
  );
};

export default Developers;
